import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

export function UsersFilter({
  onFiltered,
  initialUsers,
  multiple = true,
  placeholder = "Usuários",
}) {
  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadUsers();
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (
      Array.isArray(initialUsers) &&
      Array.isArray(users) &&
      users.length > 0
    ) {
      setSelecteds(initialUsers);
    } else {
      setSelecteds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialUsers, users]);

  const loadUsers = async () => {
    try {
      const { data } = await api.get("/users/list");
      const userList = data.map((u) => ({ id: u.id, name: u.name }));
      setUsers(userList);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    const normalizedValue = multiple ? value || [] : value ? [value] : [];
    setSelecteds(normalizedValue);
    onFiltered(normalizedValue);
  };

  return (
    <Box>
      <Autocomplete
        multiple={multiple}
        size="small"
        options={users}
        value={multiple ? selecteds : selecteds[0] || null}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option?.name || ""}
        getOptionSelected={(option, value) => {
          const optionName = (option?.name || "").toLowerCase();
          const valueName = (value?.name || "").toLowerCase();
          return option?.id === value?.id || optionName === valueName;
        }}
        renderTags={(value, getUserProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: "#bfbfbf",
                textShadow: "1px 1px 1px #000",
                color: "white",
              }}
              label={option.name}
              {...getUserProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
          />
        )}
      />
    </Box>
  );
}
